
import { Link } from "@mui/material";
import { useEffect, useState } from "react";

const SidebarItem = ({ item }) => {
  const [open, setOpen] = useState(false)
  const [activeIndex, setActiveIndex] = useState()
  const [activeIndexChild, setActiveIndexChild] = useState()  

  useEffect(() => {    
    const curPath = window.location.pathname.split('/')[1]
    
    if (!item.Path) {
      if (item.SeccionChild === curPath) {
        setActiveIndex(item.IdPadre)
        setActiveIndexChild(item.IdSubMenu)

        document.getElementById(`sidebar_${item.IdPadre}`).classList.add('open')
      }
    } else {
      if (item.Seccion === curPath) {
        setActiveIndex(1)
      }
    }
  }, [item])

  if (item.SubMenus?.length > 0) {
    return (
      <div className={`${open ? 'sidebar-item open' : 'sidebar-item'}`} id={`sidebar_${item.IdMenu}`}>
        <div className='sidebar-title'>
          <span className='text-white d-flex align-items-center'>
            {item.Icono && <i className={`${item.Icono} me-2`}></i>}
            {item.Menu}
          </span> 
          <i className='bx bx-chevron-down toggle-btn text-white' onClick={() => setOpen(!open)}></i>
        </div>
        <div className='sidebar-content'>
          {item.SubMenus.map((child, index) => <SidebarItem key={index} item={child} />)}
        </div>
      </div>
    )
  } else {    
    if (item.Path) {
      if (item.IsVisible) {
        return (
          <Link href={item.Path || '#'} className={`sidebar-item plain border-bottom ${activeIndex === 1 ? 'active' : ''}`} style={{ padding: 18 }}>
            {item.Icono && <i className={`${item.Icono} me-2`}></i>}
            {item.Menu}
          </Link>
        )
      }
    } else {
      return (
        <Link href={item.PathChild || '#'} className={`sidebar-item plain ${item.IdSubMenu === activeIndexChild ? 'active' : ''}`}>
          {item.IconoChild && <i className={`${item.IconoChild} me-2`}></i>}
          {item.MenuChild}
        </Link>
      )
    }
  }
}

export default SidebarItem;